import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip } from 'recharts';
import DashboardCard, {
    ChartBody,
    ChartEmpty,
    ChartPlot,
    ChartTooltip,
    chartTick,
    chartTickSans,
} from './DashboardCard';

interface ConversationsByChannelChartProps {
    data: { name: string; conversas: number }[];
    isLoading?: boolean;
}

const shortChannelName = (value: string) =>
    value.length > 16 ? `${value.slice(0, 15)}…` : value;

const ConversationsByChannelChart: React.FC<ConversationsByChannelChartProps> = ({
    data,
    isLoading = false,
}) => {
    return (
        <DashboardCard title="Conversas por canal">
            {isLoading ? (
                <div className="h-52 animate-pulse rounded-xl bg-surface-subtle md:h-56" />
            ) : data.length === 0 ? (
                <ChartEmpty>Sem conversas neste período.</ChartEmpty>
            ) : (
                <ChartBody>
                    <ChartPlot>
                        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 12, left: 4, bottom: 0 }}>
                            <XAxis
                                type="number"
                                tick={chartTick}
                                tickLine={false}
                                axisLine={false}
                                allowDecimals={false}
                            />
                            <YAxis
                                type="category"
                                dataKey="name"
                                tick={chartTickSans}
                                tickFormatter={shortChannelName}
                                tickLine={false}
                                axisLine={false}
                                width={108}
                            />
                            <Tooltip
                                cursor={{ fill: 'var(--color-surface-subtle)' }}
                                content={<ChartTooltip />}
                            />
                            <Bar
                                dataKey="conversas"
                                name="Conversas"
                                fill="var(--color-primary)"
                                radius={[0, 6, 6, 0]}
                                maxBarSize={28}
                            />
                        </BarChart>
                    </ChartPlot>
                </ChartBody>
            )}
        </DashboardCard>
    );
};

export default ConversationsByChannelChart;
